import { render, staticRenderFns } from "./protected_badge.vue?vue&type=template&id=a4bb36b6"
import script from "./protected_badge.vue?vue&type=script&lang=js"
export * from "./protected_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports